/**
 * The five places tour-page settings actually land on the storefront.
 *
 * Shared because BOTH ends must agree on the spelling: operator-web builds
 * `?highlight=<surface>` to point its preview at one of them, traveler-web
 * marks the matching element with `data-tour-page-surface` and rings whichever
 * one the query names. A typo on either side is a preview that silently shows
 * the top of the page instead — so the names live in one place and both sides
 * import them.
 */
export const TOUR_PAGE_SURFACES = [
  "recommended-on",
  "trust-badges",
  "award",
  "whatsapp",
  "departure-details",
] as const;

export type TourPageSurface = (typeof TOUR_PAGE_SURFACES)[number];

/** The query parameter operator-web appends and traveler-web reads. */
export const TOUR_PAGE_HIGHLIGHT_PARAM = "highlight";

/** The DOM attribute that marks a surface on the storefront. */
export const TOUR_PAGE_SURFACE_ATTR = "data-tour-page-surface";

export function isTourPageSurface(value: string): value is TourPageSurface {
  return (TOUR_PAGE_SURFACES as readonly string[]).includes(value);
}

/** Spread onto the storefront element that IS this surface. One spelling of the
 *  attribute name, and the compiler checks the value. */
export function tourPageSurfaceProps(
  surface: TourPageSurface,
): Record<string, string> {
  return { [TOUR_PAGE_SURFACE_ATTR]: surface };
}
